import React from 'react';
import { Interfaces } from 'doodle-icons';

export type PersonaId = 'teacher' | 'center-owner' | 'school-leader' | 'student-parent';

export interface PersonaMeta {
  id: PersonaId;
  label: string;
  shortLabel: string;
  tagline: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const PERSONAS: PersonaMeta[] = [
  {
    id: 'teacher',
    label: 'I\u2019m a Teacher',
    shortLabel: 'Teacher',
    tagline: 'Grade faster, teach better.',
    icon: Interfaces.Pencil,
  },
  {
    id: 'center-owner',
    label: 'I run a Tutoring Center',
    shortLabel: 'Center Owner',
    tagline: 'Scale without more staff.',
    icon: Interfaces.Home,
  },
  {
    id: 'school-leader',
    label: 'I\u2019m a School Leader',
    shortLabel: 'School Leader',
    tagline: 'Data-driven teaching.',
    icon: Interfaces.Analytics,
  },
  {
    id: 'student-parent',
    label: 'I\u2019m a Student or Parent',
    shortLabel: 'Student/Parent',
    tagline: 'Understand every grade.',
    icon: Interfaces.User,
  },
];

export function getPersona(id: PersonaId): PersonaMeta {
  return PERSONAS.find((p) => p.id === id)!;
}
